import { render } from "./PickSigner.vue?vue&type=template&id=4a0675cd&scoped=true"
import script from "./PickSigner.vue?vue&type=script&lang=js"
export * from "./PickSigner.vue?vue&type=script&lang=js"

import "./PickSigner.vue?vue&type=style&index=0&id=4a0675cd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0675cd"]])

export default __exports__